/**
 * Dashboard/Reports shared constants
 */

export const PREVIEW_ROW_LIMIT = 1000;

export const ENTITY_TYPES = [
  { value: 'hosts', label: 'Hosts' },
  { value: 'metrics', label: 'Metrics' },
  { value: 'business_services', label: 'Business Services' },
  { value: 'host_groups', label: 'Host Groups' },
];

export const TABLE_TO_ENTITY_TYPE_MAP = {
  hosts: 'hosts',
  host_groups: 'host_groups',
  business_services: 'business_services',
  metrics: 'metrics',
};

export const getEntityTypeFromTable = (tableName) => {
  if (!tableName) return 'metrics';
  const normalizedTable = tableName.toLowerCase();
  return TABLE_TO_ENTITY_TYPE_MAP[normalizedTable] || 'metrics';
};

export const REQUIRED_FILTER_TYPES = [
  'host',
  'host_group',
  'host_category',
  'business_service',
  'metric',
  'metric_category',
  'time_range',
  'host_status',
  'metric_status',
];

export const REQUIRED_FILTER_TO_ENTITY_MAP = {
  host: 'hosts',
  host_group: 'host_groups',
  business_service: 'business_services',
  metric: 'metrics',
};

export const ENTITY_FILTER_RULES = {
  // All entity filters apply to all tables (unless table doesn't support it in QueryBuilderService)
  // The server-side QueryBuilderService handles the logic of how to filter each table
  metrics: ['metrics', 'hosts', 'host_groups', 'business_services'],
  hosts: ['hosts', 'host_groups', 'business_services'],
  host_groups: ['host_groups', 'business_services'],
  business_services: ['business_services'],
  events: ['hosts', 'metrics', 'host_groups', 'business_services'],
  event_handlers: ['hosts', 'metrics', 'host_groups', 'business_services'],
};

/**
 * Valid predefined time range values for reports
 */
export const VALID_TIME_RANGES = [
  'last_1h',
  'last_24h',
  'last_7d',
  'last_30d',
  'last_90d',
  'last_365d',
];
